export default __webpack_public_path__ + "static/media/panic-button-advanced.9554e058.png";